<script setup lang="ts">
/**
 * Which of the document's named text styles something is set in.
 *
 * Shared by every inspector that offers one (prose, a heading, a text placed
 * freely), so the choice reads the same wherever it is made. Shown only when
 * the document has styles to choose from.
 */
import { useI18n } from 'vue-i18n'

import InspectorField from '@/sections/InspectorField.vue'
import { useReportStore } from '@/stores/report'

defineProps<{ value: string; hint?: string }>()
const emit = defineEmits<{ change: [id: string] }>()

const { t } = useI18n()
const report = useReportStore()
</script>

<template>
  <InspectorField
    v-if="report.layout.textStyles.length"
    :label="t('inspector.text.textStyle')"
    :hint="hint ?? t('inspector.text.textStyleHint')"
  >
    <select
      class="b-input"
      :value="value"
      @change="emit('change', ($event.target as HTMLSelectElement).value)"
    >
      <option value="">{{ t('inspector.text.textStyleNone') }}</option>
      <option v-for="style in report.layout.textStyles" :key="style.id" :value="style.id">
        {{ style.name }}
      </option>
    </select>
  </InspectorField>
</template>
